module.exports = __webpack_public_path__ + "static/img/bg.2a38ad3d.png";